import React, { useState } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  // selectFilter,
} from "react-bootstrap-table2-filter";

import LoadingAlert from "../../components/LoadingAlert";

import { toast } from "react-toastify";

//Import ConfirmAlert
import { confirmAlert } from "react-confirm-alert";

import ToolkitProvider from "react-bootstrap-table2-toolkit";
// const { SearchBar } = Search;

// Import Service
import ContractService from "../../services/contract.service";
import RegsugarService from "../../services/regsugar.service";
import authService from "../../services/auth.service";

//Import Modal
import ModalContract from "./ModalContract";

// import moment from "moment/min/moment-with-locales";
import moment from "moment";
import "moment/locale/th";
moment.locale("th");

// //Import Loading
// import Spinner from "react-bootstrap/Spinner";

//import css
import "./listregsugarcane.css";
// import authService from "../../services/auth.service";
// const user = authService.getCurrentUser();

const ListRegsugarcaneContract = () => {
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [contract, setContract] = useState([]);
  const [selectid, setSelectid] = useState([]);
  const [select_row_id, setSelect_row_id] = useState([]);
  const [loadingAlert, setLoadingAlert] = useState(false);
  const [show, setShow] = useState(false);
  // const [select_sent, setSelect_sent] = useState("0");

  //   const [show, setShow] = useState(false);
  //   const [farmerselect, farmerSetselect] = useState({});

  const user = authService.getCurrentUser();

  // useEffect(() => {
  // }, []);

  const onSelectChange = (e) => {
    // getContract();
    // setSelect_sent(e.target.value);
    if (e.target.value == "0") {
      setData([]);
    } else {
      getData(e.target.value);
    }
  };

  const getData = (select) => {
    setLoadingAlert(true);
    ContractService.getCheckNo3Years(select)
      .then((response) => {
        console.log(response.data.data);
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoadingAlert(false);
      });
  };

  // const getContract = (person_card_id) => {
  //   console.log(person_card_id);
  //   setLoadingAlert(true);
  //   ContractService.getContractByID(person_card_id)
  //     .then((response) => {
  //       setContract(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.error("error fetching data: ", error);
  //       setError(error);
  //     })
  //     .finally(() => {
  //       setLoadingAlert(false);
  //     });
  // };

  const getContract = (person_card_id) => {
    // ContractService.getContractByID(person_card_id).then((response) => {
    //   console.log(response.data.data);
    //   setContract(response.data.data);
    // });
    ContractService.getContractByID({ thai_no: person_card_id }).then(
      (response) => {
        setContract(response.data.data);
        setShow(true);
      }
    );
  };

  const handleClick = (status) => {
    confirmAlert({
      title: "",
      message:
        status == "ส่งปกติ"
          ? "แก้ไขเป็นส่งปกติ จำนวน " + selectid.length + " คน"
          : "อนุมัติพ้นสภาพ จำนวน " + selectid.length + " คน",
      buttons: [
        {
          label: "ใช่",
          onClick: () => {
            setLoadingAlert(true);
            RegsugarService.approveStatusContract({
              regsugar_ids: selectid,
              user_id: user.user.user_id,
              status: status,
            })
              .then((response) => {
                // arr1.map((obj) => arr2.find((o) => o.id === obj.id) || obj);

                setData((items) => {
                  return [
                    ...items.map((item) => {
                      const result = response.data.data.find(
                        (o) => o.regsugar_id === item.regsugar_id
                      );
                      if (result) {
                        return {
                          ...item,
                          status: result.status_text,
                          end_date: result.end_date,
                        };
                      } else {
                        return item;
                      }
                    }),
                  ];
                });
                setSelectid([]);
                setSelect_row_id([]);
                toast.success("บันทึกข้อมูลเรียบร้อย");
              })
              .catch((err) => {
                toast.error(err);
              })
              .finally(() => setLoadingAlert(false));
          },
        },
        {
          label: "ไม่ใช่",
          onClick: () => false,
        },
      ],
      overlayClassName: "confirm-alert-default",
    });
  };

  const clickShowModal = (row) => {
    // alert(JSON.stringify(row));
    // setContract(row);
    getContract(row.person_card_id);
  };
  const actionsViewtFormatter = (cell, row) => {
    return (
      <>
        <i
          className="bi bi-search custom-icon-table"
          onClick={() => clickShowModal(row)}
        ></i>
      </>
    );
  };

  const columns = [
    {
      text: "regsugar_id",
      dataField: "regsugar_id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "person_card_id",
      dataField: "person_card_id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ-สกุล",
      dataField: "farmer_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "left",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ชาวไร่",
      dataField: "status",
      sort: true,
      editable: false,
      formatter: (cell) => {
        if (cell == "พ้นสภาพ") {
          return <span style={{ color: "red" }}>{cell}</span>;
        } else {
          return <span style={{ color: "green" }}>{cell}</span>;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },

    {
      text: "รหัสเกษตร",
      dataField: "farmer_card_id",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
    {
      text: "วันที่เริ่ม",
      dataField: "start_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
    {
      text: "วันที่สิ้นสุด",
      dataField: "end_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
    {
      text: "วันที่ตรวจสอบ",
      dataField: "contract_check_date",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      formatter: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell) => {
        if (cell != "-") {
          return moment(new Date(cell)).add(543, "year").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
      },
      // filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "คู่สัญญา",
      // dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: actionsViewtFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "center",
      },
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  // const getAllIndexes = (arr) => {
  //   var indexes = [],
  //     i;
  //   for (i = 0; i < arr.length; i++)
  //     // if (arr[i] === val)
  //     indexes.push(i);
  //   return indexes;
  // };

  const selectRow = {
    mode: "checkbox",
    // clickToSelect: select_sent == "1" ? true : false,
    selected: select_row_id,
    // nonSelectable: select_sent == "1" ? [] : getAllIndexes(data),
    onSelect: (row, isSelect, rowIndex, e) => {
      console.log(row);
      console.log(isSelect);
      console.log(rowIndex);
      console.log(e);
      if (
        !selectid.some((item) => row.regsugar_id === item.regsugar_id) &&
        isSelect
      ) {
        const selectedData = {
          regsugar_id: row.regsugar_id,
        };
        setSelectid((a) => [...a, selectedData]);
        setSelect_row_id([...select_row_id, row.regsugar_id]);
      } else {
        setSelectid(
          selectid.filter((item) => item.regsugar_id !== row.regsugar_id)
        );
        setSelect_row_id(
          select_row_id.filter((item) => item !== row.regsugar_id)
        );
      }
    },
    onSelectAll: (isSelect, rows, e) => {
      console.log(isSelect);
      if (isSelect) {
        rows.map((item) => {
          setSelectid((a) => [...a, { regsugar_id: item.regsugar_id }]);
          setSelect_row_id((a) => [...a, item.regsugar_id]);
        });
      } else {
        rows.map((item) => {
          setSelectid((aa) =>
            aa.filter((a) => a.regsugar_id !== item.regsugar_id)
          );
          setSelect_row_id((aa) => aa.filter((a) => a !== item.regsugar_id));
        });
      }
      console.log(rows);
      console.log(e);
    },
  };

  // if (loading)
  //   return (
  //     <>
  //       <Spinner animation="border" variant="primary" />
  //       <span>กรุณารอข้อมูลเนื่องจากมีข้อมุลจำนวนมาก</span>
  //     </>
  //   );
  if (error) return `Error :${error}`;

  return (
    <div>
      {loadingAlert ? <LoadingAlert /> : ""}
      <ModalContract show={show} setShow={(a) => setShow(a)} data={contract} />
      {/* <ModalContract
        show={show}
        data={contract}
        setdata={(b) => setData(b)}
        hidden={(a) => setShow(a)}
      /> */}
      <ToolkitProvider
        bootstrap4
        keyField="regsugar_id"
        data={data}
        columns={columns}
        search
      >
        {(prop) => (
          <>
            <div className="row">
              <div className="col-md-9">
                <button
                  className="btn btn-success"
                  onClick={() => handleClick("ส่งปกติ")}
                  style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
                >
                  แก้ไขเป็นส่งปกติ
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => handleClick("พ้นสภาพ")}
                  style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
                >
                  อนุมัติพ้นสภาพ
                </button>
                {/* <SearchBar {...prop.searchProps} /> */}
                {selectid.length > 0
                  ? "จำนวน " + selectid.length + " ที่เลือก"
                  : ""}
              </div>
              <div className="col-md-3 text-right">
                <select
                  className="form-select"
                  onChange={(e) => onSelectChange(e)}
                >
                  <option key={0} value="0">
                    กรุณาเลือกการส่งอ้อย
                  </option>
                  <option key={1} value="1">
                    ขาดส่งอ้อย
                  </option>
                  <option key={2} value="2">
                    ส่งอ้อยปกติ
                  </option>
                </select>
              </div>
            </div>
            <div style={{ width: "auto" }}>
              <BootstrapTable
                selectRow={selectRow}
                bootstrap4
                // keyField="regsugar_id"
                // columns={columns}
                // data={data}
                pagination={pagination}
                //   cellEdit={cellEditFactory({
                //     mode: "click",
                //     blurToSave: true,
                //     afterSaveCell,
                //   })}
                filter={filterFactory()}
                // loading={true}
                {...prop.baseProps}
              />
            </div>
          </>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default ListRegsugarcaneContract;
